var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('subscribe',{on:{"subscription-complete":function($event){return _vm.$router.replace({ name: 'home' })}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }